import { render } from "./FormGoals.vue?vue&type=template&id=6474a744&scoped=true"
import script from "./FormGoals.vue?vue&type=script&lang=js"
export * from "./FormGoals.vue?vue&type=script&lang=js"

import "./FormGoals.vue?vue&type=style&index=0&id=6474a744&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6474a744"

export default script